export const inputMaxValues = {
    MAX_TITLE_CHARACTERS: 101, // set to one above allows check to equality even if undefined
    MAX_DESCRIPTION_WORDS: 201,
    MAX_WORD_COUNT: 200,
    MAX_TAG_LENGTH: 100,
    MAX_TAG_COUNT: 20,
};
